export default __webpack_public_path__ + "static/section-services-1-0d12dd9ea077f56868c5bd2d2e0eaf68.jpg";